// extracted by mini-css-extract-plugin
module.exports = {"menu":"Styles_menu__1NkpL"};